import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'

import { DiscoveryBox } from '@/components/molecules/DiscoveryBox/DiscoveryBox'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { DiscoveryProps } from './types'
import * as styles from './DiscoverySection.module.css'

export function DiscoverySection({ title, discovery_boxes, resources_title, resources_links }: DiscoveryProps) {
  return (
    <section
      className={clsx(styles.sectionBg, 'mx-auto p-24 laptop:px-90 text-left netbook:py-64')}
      id={kebabCase(title)}
    >
      <div className="max-w-90 lg:mx-auto">
        {title && (
          <h1 className="font-poppins font-bold text-text-dark-900 text-headingL-mobile tablet:text-headingL mb-24 tablet:mb-4 netbook:mb-56">
            {title}
          </h1>
        )}
        <div className="flex flex-col tablet:flex-row tablet:justify-between netbook:items-strech">
          <ul
            className="flex flex-col w-full tablet:flex-row tablet:flex-wrap tablet:w-6/12 tablet:justify-between
        netbook:w-[55%] h-full"
          >
            {discovery_boxes.length && discovery_boxes.map((box) => <DiscoveryBox key={box._uid} {...box} />)}
          </ul>
          <div className={clsx(styles.wrapper, 'relative flex flex-col w-full tablet:w-5/12 netbook:w-4/12 h-auto')}>
            {resources_title && (
              <h2
                className="font-poppins font-bold text-text-dark-900 text-headingS-mobile bg-white
          tablet:text-headingS mb-12 tablet:mb-8 w-full leading-14"
              >
                {resources_title}
              </h2>
            )}
            {resources_links?.length && (
              <ul>
                {resources_links?.map((topic) => (
                  <li key={topic._uid} className={clsx('relative w-11/12 py-24 group', styles.listItem)}>
                    <CustomLink {...topic.link[0]}>
                      <h3 className="text-headingS-mobile font-poppins text-primary-600 font-bold mb-16">
                        {topic.link[0]?.text}
                      </h3>
                      {topic.description.length && (
                        <p className="font-mulish flex flex-col text-text-dark-900 group-hover:text-primary-600 mb-2 leading-8 text-bodyL">
                          {topic.description}
                        </p>
                      )}
                    </CustomLink>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
